// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:eafc30de-5040-4205-950b-15f33aa72700",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_7jnpOngb5",
    "aws_user_pools_web_client_id": "40dadns2o0r0q46nhn35tein47",
    Auth: {
        // REQUIRED - Amazon Cognito Identity Pool ID
        identityPoolId: 'eu-central-1:eafc30de-5040-4205-950b-15f33aa72700',
        // REQUIRED - Amazon Cognito Region
        region: 'eu-central-1', 
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'eu-central-1_7jnpOngb5', 
        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '40dadns2o0r0q46nhn35tein47',
    },
    API: {
        endpoints: [
            {
                name: "DZI",
                endpoint: "https://n23ao6on11.execute-api.eu-central-1.amazonaws.com"
            }
        ]
    }
};


export default awsmobile;
